module.exports = __webpack_public_path__ + "static/media/scanQrcodetoGetTickets.cb031c0b.mp4";